import { render } from "./notification-create.vue?vue&type=template&id=17ab8974"
import script from "./notification-create.vue?vue&type=script&lang=js"
export * from "./notification-create.vue?vue&type=script&lang=js"

import "./notification-create.vue?vue&type=style&index=0&id=17ab8974&lang=scss"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__